window.Reverb = window.Reverb || {};

Reverb.RefundRequestAdjustment = (function () {
  const refundAmount = '[data-refund-original-amount]';

  function init() {
    $(document).on('input', refundAmount, adjustSellerFees);
  }

  function adjustSellerFees() {
    const $refundAmountInput = $(this);
    if ($refundAmountInput.val() < $refundAmountInput.data('refund-original-amount')) {
      $($refundAmountInput.data('full')).hide();
      $($refundAmountInput.data('partial')).show();
    } else {
      $($refundAmountInput.data('full')).show();
      $($refundAmountInput.data('partial')).hide();
    }
  }

  return {
    init,
  };
}());

$(document).ready(Reverb.RefundRequestAdjustment.init);
